import * as actionTypes from './timeSlotsActionTypes';

// Actions happening in doctors page
export function getMyTimeSlots() {
  return { type: actionTypes.GET_MY_TIMESLOTS };
}

export function addThisTimeSlot(data) {
  return { type: actionTypes.ADD_THIS_TIME_SLOT, data };
}

export function deleteThisTimeSlot(_id) {
  return { type: actionTypes.DELETE_THIS_TIME_SLOT, _id };
}
